import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { catchError, filter, firstValueFrom, Observable, timeout } from 'rxjs';
import { AuthService } from '@app/services/auth/auth';
import { PusherConnectionService } from '@app/services/pusher-connection/pusher-connection';

const TIMEOUT_MS = 15_000;

export async function pusherInitializer(): Promise<void> {
  if (!isPlatformBrowser(inject(PLATFORM_ID))) {
    return;
  }

  const authService = inject(AuthService);
  const pusherConnection = inject(PusherConnectionService);

  if (!authService.isAuthenticated()) {
    return;
  }

  await firstValueFrom(
    pusherConnection.isReady$.pipe(
      filter((ready: boolean) => ready),
      timeout(TIMEOUT_MS),
      catchError((): Observable<boolean> => emitFalse()),
    ),
  );
}

function emitFalse(): Observable<boolean> {
  return new Observable<boolean>(subscriber => {
    subscriber.next(false);
    subscriber.complete();
  });
}
